import { createActionGroup, props } from '@ngrx/store';
import { LoadPropertyDetailsActionParams } from '../../models/property.model';
import { GetPropertyDetailsResponseModel } from '../../../shared/models/properties/properties.models';

interface LoadPropertyDetailsFailurePayload {
  error: unknown;
}

export const PropertyDetailsActions = createActionGroup({
  source: 'PROPERTY',
  events: {
    'Load Property Details': props<LoadPropertyDetailsActionParams>(),
    'Load Property Details Success': props<GetPropertyDetailsResponseModel>(),
    'Load Property Details Failure': props<LoadPropertyDetailsFailurePayload>()
  }
})